var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('we-editor',{attrs:{"toolbar-option":_vm.toolbar,"editable-option":_vm.editable,"html":_vm.editorContent},on:{"update:html":function($event){_vm.editorContent=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }